import React from 'react'
import {SideBarBg} from './styles';

const Sidebar = () => {
    return (
        <SideBarBg lg={4} md={4} className="d-none d-md-block d-lg-block" />
    )
}

export default Sidebar